<template>
  <header class="header"
  >
    <div class="header__container flex">
      <svg class="header__menu"
          @click="isActiveBarraLateralIzquierda=!isActiveBarraLateralIzquierda;"
          width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 18C3.71667 18 3.47917 17.9042 3.2875 17.7125C3.09583 17.5208 3 17.2833 3 17C3 16.7167 3.09583 16.4792 3.2875 16.2875C3.47917 16.0958 3.71667 16 4 16H20C20.2833 16 20.5208 16.0958 20.7125 16.2875C20.9042 16.4792 21 16.7167 21 17C21 17.2833 20.9042 17.5208 20.7125 17.7125C20.5208 17.9042 20.2833 18 20 18H4ZM4 13C3.71667 13 3.47917 12.9042 3.2875 12.7125C3.09583 12.5208 3 12.2833 3 12C3 11.7167 3.09583 11.4792 3.2875 11.2875C3.47917 11.0958 3.71667 11 4 11H20C20.2833 11 20.5208 11.0958 20.7125 11.2875C20.9042 11.4792 21 11.7167 21 12C21 12.2833 20.9042 12.5208 20.7125 12.7125C20.5208 12.9042 20.2833 13 20 13H4ZM4 8C3.71667 8 3.47917 7.90417 3.2875 7.7125C3.09583 7.52083 3 7.28333 3 7C3 6.71667 3.09583 6.47917 3.2875 6.2875C3.47917 6.09583 3.71667 6 4 6H20C20.2833 6 20.5208 6.09583 20.7125 6.2875C20.9042 6.47917 21 6.71667 21 7C21 7.28333 20.9042 7.52083 20.7125 7.7125C20.5208 7.90417 20.2833 8 20 8H4Z" fill="currentColor"/>
      </svg>
      <div class="header__logo"
          @click="$emit('close');this.$router.push('/')"
      >
      </div>
      <nav class="header__nav">
        <ul class="header__list">
          <li class="header__items"
              @click="$emit('close');this.$router.push('/')"
              :class="{'header__item__active-scroll':scrollPosition >= 50, 'header__item__active': routeName === 'home'}"
              :style="routeName === 'home' && scrollPosition >= 50? 'color: #fecb00' : ''"
          >
            {{ $t('header.txt_inicio') }}
          </li>
          <li class="header__items"
              @click="$emit('close');this.$router.push({name: 'menudigital'})"
              :class="[{ 'header__item__active': rutasDeCarta.includes(routeName) },
                { 'header__item__active-scroll': scrollPosition >= 50 }
              ]"
              :style="rutasDeCarta.includes(routeName) && scrollPosition >= 50? 'color: #fecb00' : ''"
          >
            {{ $t('header.txt_carta') }}
          </li>
          <li class="header__items"
              @click="$emit('close');$router.push('/locales');"
              :class="[routeName === 'locales' ? 'header__item__active' : '', { 'header__item__active-scroll': scrollPosition >= 50 }]"
              :style="routeName === 'locales' && scrollPosition >= 50? 'color: #fecb00' : ''"
          >
            {{ $t('header.txt_cobertura') }}
          </li>
          <li class="header__items"
              v-if="isAuthenticated"
              @click="$emit('close');this.$router.push({path: '/perfil/beneficios'});"
              :class="[routeName === 'perfil.beneficios' ? 'header__item__active' : '', { 'header__item__active-scroll': scrollPosition >= 50 }]"
              :style="routeName === 'perfil.beneficios' && scrollPosition >= 50? 'color: #fecb00' : ''"
          >
            {{ $t('header.txt_beneficios') }}
          </li>
<!--          <li class="header__items"-->
<!--              @click="$emit('close');this.$router.push('/reservas')"-->
<!--              :class="{'header__item__active-scroll':scrollPosition >= 50, 'header__item__active': routeName === 'reservas'}"-->
<!--              :style="routeName === 'reservas' && scrollPosition >= 50? 'color: #fecb00' : ''"-->
<!--          >-->
<!--            Reservas-->
<!--          </li>-->
        </ul>
      </nav>
      <div class="header__login-cart flex">
        <div class="header__login flex"
            @click="openLoginRegister" v-if="!isAuthenticated">
          <svg
              :style="routeName === 'perfil.cuenta' && scrollPosition >= 50? 'color: #fecb00' : ''"
              width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.85 17.1C6.7 16.45 7.65 15.9375 8.7 15.5625C9.75 15.1875 10.85 15 12 15C13.15 15 14.25 15.1875 15.3 15.5625C16.35 15.9375 17.3 16.45 18.15 17.1C18.7333 16.4167 19.1875 15.6417 19.5125 14.775C19.8375 13.9083 20 12.9833 20 12C20 9.78333 19.2208 7.89583 17.6625 6.3375C16.1042 4.77917 14.2167 4 12 4C9.78333 4 7.89583 4.77917 6.3375 6.3375C4.77917 7.89583 4 9.78333 4 12C4 12.9833 4.1625 13.9083 4.4875 14.775C4.8125 15.6417 5.26667 16.4167 5.85 17.1ZM12 13C11.0167 13 10.1875 12.6625 9.5125 11.9875C8.8375 11.3125 8.5 10.4833 8.5 9.5C8.5 8.51667 8.8375 7.6875 9.5125 7.0125C10.1875 6.3375 11.0167 6 12 6C12.9833 6 13.8125 6.3375 14.4875 7.0125C15.1625 7.6875 15.5 8.51667 15.5 9.5C15.5 10.4833 15.1625 11.3125 14.4875 11.9875C13.8125 12.6625 12.9833 13 12 13ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C12.8833 20 13.7167 19.8708 14.5 19.6125C15.2833 19.3542 16 18.9833 16.65 18.5C16 18.0167 15.2833 17.6458 14.5 17.3875C13.7167 17.1292 12.8833 17 12 17C11.1167 17 10.2833 17.1292 9.5 17.3875C8.71667 17.6458 8 18.0167 7.35 18.5C8 18.9833 8.71667 19.3542 9.5 19.6125C10.2833 19.8708 11.1167 20 12 20ZM12 11C12.4333 11 12.7917 10.8583 13.075 10.575C13.3583 10.2917 13.5 9.93333 13.5 9.5C13.5 9.06667 13.3583 8.70833 13.075 8.425C12.7917 8.14167 12.4333 8 12 8C11.5667 8 11.2083 8.14167 10.925 8.425C10.6417 8.70833 10.5 9.06667 10.5 9.5C10.5 9.93333 10.6417 10.2917 10.925 10.575C11.2083 10.8583 11.5667 11 12 11Z" fill="currentColor"/>
          </svg>
          <li class="header__items">
            {{ $t('header.txt_ingresar') }}
          </li>
        </div>
        <div class="header__login flex" @click="$router.push('/perfil/cuenta')" v-if="isAuthenticated">
          <svg
              :class="[routeName === 'perfil.cuenta' ? 'header__item__active' : '', { 'header__item__active-scroll': scrollPosition >= 50 }]"
              :style="routeName === 'perfil.cuenta' && scrollPosition >= 50? 'color: #fecb00' : ''"
              width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.85 17.1C6.7 16.45 7.65 15.9375 8.7 15.5625C9.75 15.1875 10.85 15 12 15C13.15 15 14.25 15.1875 15.3 15.5625C16.35 15.9375 17.3 16.45 18.15 17.1C18.7333 16.4167 19.1875 15.6417 19.5125 14.775C19.8375 13.9083 20 12.9833 20 12C20 9.78333 19.2208 7.89583 17.6625 6.3375C16.1042 4.77917 14.2167 4 12 4C9.78333 4 7.89583 4.77917 6.3375 6.3375C4.77917 7.89583 4 9.78333 4 12C4 12.9833 4.1625 13.9083 4.4875 14.775C4.8125 15.6417 5.26667 16.4167 5.85 17.1ZM12 13C11.0167 13 10.1875 12.6625 9.5125 11.9875C8.8375 11.3125 8.5 10.4833 8.5 9.5C8.5 8.51667 8.8375 7.6875 9.5125 7.0125C10.1875 6.3375 11.0167 6 12 6C12.9833 6 13.8125 6.3375 14.4875 7.0125C15.1625 7.6875 15.5 8.51667 15.5 9.5C15.5 10.4833 15.1625 11.3125 14.4875 11.9875C13.8125 12.6625 12.9833 13 12 13ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C12.8833 20 13.7167 19.8708 14.5 19.6125C15.2833 19.3542 16 18.9833 16.65 18.5C16 18.0167 15.2833 17.6458 14.5 17.3875C13.7167 17.1292 12.8833 17 12 17C11.1167 17 10.2833 17.1292 9.5 17.3875C8.71667 17.6458 8 18.0167 7.35 18.5C8 18.9833 8.71667 19.3542 9.5 19.6125C10.2833 19.8708 11.1167 20 12 20ZM12 11C12.4333 11 12.7917 10.8583 13.075 10.575C13.3583 10.2917 13.5 9.93333 13.5 9.5C13.5 9.06667 13.3583 8.70833 13.075 8.425C12.7917 8.14167 12.4333 8 12 8C11.5667 8 11.2083 8.14167 10.925 8.425C10.6417 8.70833 10.5 9.06667 10.5 9.5C10.5 9.93333 10.6417 10.2917 10.925 10.575C11.2083 10.8583 11.5667 11 12 11Z" fill="currentColor"/>
          </svg>
          <li
              :class="[routeName === 'perfil.cuenta' ? 'header__item__active' : '', { 'header__item__active-scroll': scrollPosition >= 50 }]"
              :style="routeName === 'perfil.cuenta' && scrollPosition >= 50? 'color: #fecb00' : ''"
              class="header__links"
          >
            {{user.first_name}}
          </li>
        </div>
        <div class="header__shopping" :class="{
          'active-shopping': shoppingCartInfo.length > 0,
          'active-shopping-scroll': scrollPosition >= 50 && shoppingCartInfo.length > 0
        }"
             @click="openShoppingCartModal"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 22C6.45 22 5.97917 21.8042 5.5875 21.4125C5.19583 21.0208 5 20.55 5 20C5 19.45 5.19583 18.9792 5.5875 18.5875C5.97917 18.1958 6.45 18 7 18C7.55 18 8.02083 18.1958 8.4125 18.5875C8.80417 18.9792 9 19.45 9 20C9 20.55 8.80417 21.0208 8.4125 21.4125C8.02083 21.8042 7.55 22 7 22ZM17 22C16.45 22 15.9792 21.8042 15.5875 21.4125C15.1958 21.0208 15 20.55 15 20C15 19.45 15.1958 18.9792 15.5875 18.5875C15.9792 18.1958 16.45 18 17 18C17.55 18 18.0208 18.1958 18.4125 18.5875C18.8042 18.9792 19 19.45 19 20C19 20.55 18.8042 21.0208 18.4125 21.4125C18.0208 21.8042 17.55 22 17 22ZM6.15 6L8.55 11H15.55L18.3 6H6.15ZM5.2 4H19.95C20.3333 4 20.625 4.17083 20.825 4.5125C21.025 4.85417 21.0333 5.2 20.85 5.55L17.3 11.95C17.1167 12.2833 16.8708 12.5417 16.5625 12.725C16.2542 12.9083 15.9167 13 15.55 13H8.1L7 15H19V17H7C6.25 17 5.68333 16.6708 5.3 16.0125C4.91667 15.3542 4.9 14.7 5.25 14.05L6.6 11.6L3 4H1V2H4.25L5.2 4Z" fill="currentColor"/>
          </svg>
          <span v-if='shoppingCartInfo.length > 0'>{{shoppingCartInfo.length}}</span>
        </div>
      </div>
    </div>
    <BarraLateralIzquierda
        :isActive="isActiveBarraLateralIzquierda"
        :routeName="routeName"
        @close="isActiveBarraLateralIzquierda=false"
    >
    </BarraLateralIzquierda>

    <transition name="slide-fade">
      <div v-show="isActiveBarraLateralIzquierda || this.showShoppingCart === true"
           class="fondo__menu__lateral__modal"
           @click="closeShoppingCartModal(); isActiveBarraLateralIzquierda= false"
      >
      </div>
    </transition>

    <ModalMiCarrito
        :isActive="this.showShoppingCart"
        @close="closeShoppingCartModal()"
        @buy_selected="continueBuyingClicked()"
        @confirm="confirmToPay()"
    >
    </ModalMiCarrito>

  </header>
</template>

<script>
import { mapMutations, mapState } from "vuex"
import {defineAsyncComponent} from "vue";
export default {
  name: 'MainHeader',
  props: ['routeName'],
  components: {
    ModalMiCarrito: defineAsyncComponent(() => import("./MODALS/ModalMiCarrito.vue")),
    BarraLateralIzquierda: defineAsyncComponent(() => import ("./BarraLateralIzquierda.vue")),
},
  data () {
    return {
      isActiveBarraLateralIzquierda: false,
      carrito_fill: 'white',
      scrollPosition: null,
      rutasDeCarta: ['menudigital', 'menudigitalprod', 'menudigitalcat']

    }
  },
  mounted() {
    window.addEventListener('scroll', this.updateScroll);
    this.carrito_fill = 'var(--primary)'

  },
  computed: {
    ...mapState(['isAuthenticated', 'goToPayClicked', 'user', 'shoppingCartInfo', 'showShoppingCart', 'orderLocal', 'isSelfService'])
  },
  methods: {
    ...mapMutations(['clearProducts', 'setGoToPayClicked', 'setShowModalLoginRegister', 'setShowShoppingCart']),

    continueBuyingClicked() {
      this.closeShoppingCartModal();
      if (this.isSelfService) {
        console.log("orderLocal", this.orderLocal)
        this.$router.push(`/restaurantes/${this.orderLocal.id}-${this.orderLocal.name}`)
      } else {
        this.$router.push('/menudigital')
      }
    },

    openShoppingCartModal() {
      this.setShowShoppingCart(true)
    },

    closeShoppingCartModal() {
      this.setShowShoppingCart(false)
    },

    confirmToPay() {
      this.setGoToPayClicked(true)
    },
    updateScroll() {
      this.scrollPosition = window.scrollY
      if (this.scrollPosition > 55){

        this.carrito_fill = 'var(--primary)'

      } else {
        this.carrito_fill = 'var(--primary)'

      }
    },
    openLoginRegister () {
      this.setShowModalLoginRegister(true)
    },

  }
}
</script>

<style scoped>
  .fondo__menu__lateral__modal {
    width: 100%;
    height: 100dvh;
    position: fixed;
    z-index: 3;
    background: #00000060;
    left: 0;
    top: 0;
    transition: 0.3s ease all;
    cursor:pointer;
  }

  .header{
    position: sticky;
    top: 0;
    background-color: var(--primary);
    z-index: 10;
    color: var(--text-white);
    box-shadow: var(--box-shadow);
    transition: 0.15s ease all;
  }

/*  .header__scroll{
    background-color: var(--complementary);
  }*/

  .header__menu{
    display: block;
    width: 28px;
    height: 28px;
    cursor: pointer;
    transition: 0.15s ease all;
  }

  .header__items{
    transition: color .3s linear;
    cursor: pointer;
    font-family: var(--headings-font-family);
    letter-spacing: 1px;
  }

  .header__items:hover{ color: var(--complementary-second); }

  .header__item__active{
    color: var(--complementary-second);
    font-weight: var(--bold);
    text-decoration: underline;
  }

  .header__item__active-scroll{ color: var(--text-white); }

  .header__login{
    align-items: center;
    display: none;
    cursor: pointer;
    transition: all .3s linear;
  }

  .header__login:hover { color: var(--complementary-second); }

  .header__links{ font-family: var(--headings-font-family); }

  .header__shopping{
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    transition: 0.15s ease all;
    font-size: 16px;
    padding: 5px 10px;
    border-radius: 8px;
  }

  .active-shopping{
    background-color: var(--complementary) !important;
    color: var(--text-white) !important;
  }

  .active-shopping svg{ color: var(--text-white) !important; }

  /*
  .active-shopping-scroll{
    background-color: var(--primary) !important;
    color: var(--text-white) !important;
  }

  .active-shopping-scroll svg{ color: var(--text-white) !important; }
  */

  .header__scroll .header__items:hover{ color: var(--complementary-second); }
  .header__scroll .header__login:hover{ color: var(--complementary-second); }
  .header__scroll .header__shopping:hover{ color: var(--complementary-second);}

  .header__container{
    justify-content: space-between;
    align-items: center;
    max-width: 1400px;
    margin-left: auto;
    margin-right: auto;
    padding: 5px 16px;
  }

  .header__logo{
    background-image: url('../assets/images-new/header__logo.svg');
    background-size: contain;
    background-repeat: no-repeat;
    cursor: pointer;
    width: 60px;
    height: 55px;
    margin: 5px;
  }

  /*.header__logo__scroll{ background-image: url('../assets/images-new/header__logo-scroll.svg'); }*/

  .header__nav{ display: none; }

  .header__login-cart{ gap: 20px; }

  .header__shopping svg{
    display: block;
    width: 28px;
    height: 28px;
    cursor: pointer;
    transition: 0.15s ease all;
  }

  .header__shopping span{ font-weight: 800; }

  .header__login li{ display: none; }

  @media only screen and (min-width: 768px){
    .header__container{ padding: 5px 32px; }
  }

  @media only screen and (min-width: 1024px){
    .header__menu{ display: none; }
    .header__nav{ display: block }
    .header__list{
      display: flex;
      justify-content: space-around;
      align-items: center;
      gap: 30px;
      font-size: 18px;
      font-weight: var(--medium);
      width: 600px;
    }
    .header__login-cart{ gap: 30px }
    .header__login{
      display: flex;
      align-items: center;
      gap: 10px;
    }
    .header__login li{
      display: block;
      font-size: 18px;
      font-weight: var(--medium);
      cursor: pointer;
    }
  }

  @media only screen and (min-width: 1280px){
    .header__items,
    .header__login li{ font-size: 22px; }
  }
</style>